import { cn } from '@seen/ui'
import type { ComponentProps, JSX } from 'react'
import { PanelGroup } from 'react-resizable-panels'

export function ResizablePanelGroup({
  className,
  ...props
}: ComponentProps<typeof PanelGroup>): JSX.Element {
  return (
    <PanelGroup
      className={cn(
        'flex data-[panel-group-direction=vertical]:flex-col',
        'size-full print:size-auto',
        className
      )}
      {...props}
    />
  )
}
